export default __webpack_public_path__ + "static/media/Snd_TryY.54277cc8.mp3";